import FireComp from './FireComp.vue'
export default FireComp